import cn from 'classnames';

import { BankCardContainer } from '../BankCardContainer';
import styles from './BankCardSkeleton.module.scss';

export const BankCardSkeleton = () => {
  return (
    <BankCardContainer>
      <div className={styles.circle} />
      <div className={cn(styles.row, styles.skeletonTitle)} />
      <div className={styles.row} />
    </BankCardContainer>
  );
};
